export default {"src":"/login-app/[GIT_HASH]/_next/static/media/op.8bdd34ae.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};